export default __webpack_public_path__ + "static/media/bekozstore.6dddc48d.png";